export enum FilterType {
  CHECK_BOX = 'CHECK_BOX',
  DATE = 'DATE',
  DROP_DOWN = 'DROP_DOWN',
  STRING = 'STRING',
  TIME = 'TIME',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT'
}
